/** The title screen */
import kontra from 'kontra';

import BaseScene from './base';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../constants';

const { emit, keyPressed } = kontra;

export default class TitleScene extends BaseScene {
  constructor () {
    super();
    this.element = document.querySelector('.title-stuff');
    this.button = this.element.querySelector('button');
    this.button.addEventListener('click', () => {
      emit('scene-change', 'overworld');
    });
  }

  onEnter () {
    emit('reset-castles');
    this.element.classList.add('visible');
  }

  onExit () {
    this.element.classList.remove('visible');
  }

  update () {

  }

  render () {
    this.context.save();
    this.context.fillStyle = 'rgba(255, 255, 255, 1.0)';
    this.context.fillText('LATE MEDIEVAL NETWORK ENGINEER', SCREEN_WIDTH / 2 - 280, SCREEN_HEIGHT / 2 - 12);
    this.context.restore();
  }
}
